import { Box, Button, Typography } from "@mui/material";
import Logo from "../../assets/logo.png";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

const Authorize = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear local storage and log out
    localStorage.clear();
    instance.logoutRedirect({ postLogoutRedirectUri: process.env.REACT_APP_URL });
  };

  return (
    <Box
      id="authorize-page"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        maxWidth: "450px",
        margin: "0 auto",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "180px",
          height: "180px",
          margin: "0 auto 50px",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            left: "0",
            right: "0",
            top: "0",
            bottom: "0",
            background: "#F40000",
            transform: "rotate(45deg)",
            border: "5px dashed #000",
            borderRadius: "5px",
          }}
        ></Box>
        <img
          src={Logo}
          alt="logo"
          style={{ position: "absolute", left: "33%", top: "10%" }}
        />
        <Typography
          variant="h1"
          sx={{
            position: "absolute",
            color: "#fff",
            fontWeight: "700",
            fontSize: "90px",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            lineHeight: "40px",
          }}
        >
          403
        </Typography>
      </Box>
      <Typography
        variant="h2"
        sx={{
          fontSize: "33px",
          fontWeight: "700",
          textTransform: "uppercase",
          letterSpacing: "7px",
        }}
      >
        Unauthorized
      </Typography>
      <Typography
        variant="subtitle"
        mt={4}
        mb={4}
        sx={{ fontSize: "16px", fontWeight: "400" }}
      >
        You do not have AD Group permission to view the dashboard. Kindly raise request to get access.
      </Typography>
      <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
        <Button
          variant="contained"
          color="error"
          onClick={() => navigate("/core/user-roles/new-request")}
          sx={{
            marginTop: "20px",
            padding: "10px 20px",
            fontWeight: "600",
            textTransform: "uppercase",
          }}
        >
          Raise Request
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleLogout}
          sx={{
            marginTop: "20px",
            padding: "10px 20px",
            fontWeight: "600",
            textTransform: "uppercase",
          }}
        >
          Logout
        </Button>
      </Box>
    </Box>
  );
};

export default Authorize;